module.exports = __webpack_public_path__ + "img/newsletter.e3d66620.svg";